export default [
  {
    header: "Dashboards",
    icon: "HomeIcon",
    children: [
      {
        title: "eCommerce",
        route: "dashboard-ecommerce",
        icon: "ShoppingCartIcon",
      },
      {
        title: "Home",
        route: "dashboard-analytics",
        icon: "ActivityIcon",
      },
    ],
  },
];
